/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import {
  Container, Flex, LoadingOverlay, Text, Transition,
} from "@mantine/core";
import SignalsContainer from "../../../shared/signals/SignalsContainer";
import HqDetails from "../headquarters/components/HqDetails";
import useWorkspaceStore from "../../../store/workspace/workspaceStore";
import { useAccount, useContact, useCurrentUser } from "../../../hooks/QueryHooks";

const transitionStyles = {
  in: { opacity: 1, transform: "scaleX(1)" },
  out: { opacity: 0, transform: "scaleX(0)" },
  common: { transformOrigin: "right" },
  transitionProperty: "transform, opacity",
};

const InboxPage = () => {
  const workspace = useWorkspaceStore((state) => state.workspace);

  return (
    <Container fluid className=" overflow-auto w-full relative h-full bg-gray-100 px-0">
      <Flex className="w-full self-stretch" gap={12}>
        <SignalsContainer tableHeight={window.innerHeight - 230} showTitle={false} workspace={workspace} bodyClass="max-h-full" />
      </Flex>
    </Container>
  );
};
export default InboxPage;
